





























































import { Component, Prop, Vue } from "vue-property-decorator";

import ExcursionCard from "@/components/card/excursion/excursion-card.vue";
import ExcursionMap from "@/components/card/excursion/excursion-map.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";
import { IExcursion } from "@/@types/excursions/excursions";

interface ISortColumn {
  name: number;
  status: number;
}

@Component({ components: { ExcursionCard, ExcursionMap, BSwitch } })
export default class ExcursionList extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Array, default: () => [] }) excursionList!: Array<IExcursion>;
  @Prop({ type: Boolean, default: false }) categoryDeleted!: boolean;
  @Prop({ type: Boolean, default: false }) excursionDeleted!: boolean;
  @Prop({ type: String, default: "" }) category_id!: string;
  @Prop({ type: String, default: "" }) excursion_id!: string;
  @Prop({ type: String, default: "" }) search!: string;

  sortKey = "";
  sortOrder: ISortColumn = { name: 1, status: -1 };

  get excursions(): Array<IExcursion> {
    let list: Array<IExcursion> = [];

    if (this.category_id) {
      for (const exc of this.excursionList) {
        if (exc.category == this.category_id) list.push(exc);
      }
    } else list = this.excursionList;

    const search = this.search && this.search.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    if (search)
      return list.filter((item) => {
        if (item.name)
          return (
            this.$getLocale(item.name)
              .toLowerCase()
              .indexOf(search.toLowerCase()) > -1
          );
      });

    if (this.sortKey) {
      if (this.sortKey == "name") {
        list = list.slice().sort((a: IExcursion, b: IExcursion) => {
          const one = this.$getLocale(a.name);
          const two = this.$getLocale(b.name);
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }

      if (this.sortKey == "status") {
        list = list.slice().sort((a: IExcursion, b: IExcursion) => {
          const one = a.show;
          const two = b.show;
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }
      if (this.sortKey == "category") {
        list = list.slice().sort((a: IExcursion, b: IExcursion) => {
          const one = a.category;
          const two = b.category;
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }
    }

    return list;
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }

  change(data: Partial<IExcursion>, id: string): void {
    this.$emit("changeExc", data, id);
  }
}
